let total_signing_files = 0
let total_signing_recipients = 0

$(document).ready(function () {
  $("#new_signing").submit(function (e) {
    e.preventDefault()
    $.ajax({
      type: "POST",
      url: $(this).attr("action"),
      enctype: "multipart/form-data",
      data: new FormData(this),
      processData: false,
      contentType: false,
      dataType: "script",
      success: function (data) {},
    })
    $("#complete-signing-process").openModal({ dismissible: false })
  })

  $("input[name='signing_upload_type']").click(function (e) {
    if ($("input[name='signing_upload_type']:checked").val() == "template") {
      $("#signing-select-template").css("display", "block")
      $("#signing-upload-file").css("display", "none")
    } else {
      $("#signing-upload-file").css("display", "block")
      $("#signing-select-template").css("display", "none")
    }
  })

  $("#save_as_template").on("click", function () {
    if ($("#save_as_template").is(":checked")) {
      $("#set-template-name").css("display", "block")
    } else {
      $("#set-template-name").css("display", "none")
    }
  })
})

window.remove_document_signing_file_fields = function (link) {
  $(link).siblings().val(1)
  $(link).parent().parent().remove()
}

function check_last_signing_file(selected_files) {
  if ($(selected_files).children().last().find(".img-preview").val() === "") {
    $(selected_files).children().last().remove()
  }
}

window.add_document_signing_file_fields = function (link, association, fields_to_clone) {
  const selected_files = $(link).parents(".um-popup-files").children("#document-signing-files").children(".files")
  check_last_signing_file(selected_files)

  total_signing_files++

  let regexp = new RegExp("new_" + association, "g")
  selected_files.append(fields_to_clone.replace(regexp, total_signing_files))

  user_file_preview(selected_files)
}

window.add_signing_recipient_fields = function (link, association, fields_to_clone) {
  total_signing_files++

  let regexp = new RegExp("new_" + association, "g")
  $(link).parent().parent().children(".recipients-list").append(fields_to_clone.replace(regexp, total_signing_files))
}

window.remove_signing_recipient_fields = function (link) {
  $(link).siblings().val(1)
  $(link).parent().parent().remove()
}

$(".search-signing-user").keyup(function () {
  let search_signing_user = $(this)
  delay(function () {
    $(search_signing_user).parents("form").submit()
  }, 1000)
})
